/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.ApiResponse,
  SetDefaultCreditCard: (params: vp.SetMyCreditCardRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostSetMyClientCreditCard: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldSetDefaultCreditCard, setShouldSetDefaultCreditCard] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.SetMyCreditCardRequest>({
    CreditCardToken: '',
    SetAsDefault: false,
  });
  const [response, setResponse] = useState<vp.SetMyCreditCardResponse>({
    CreditCardToken: '',
    IsDefault: '0',
    Success: false,
    ErrorMessage: '',
  });

  useEffect(() => {
    if (!shouldSetDefaultCreditCard) return () => {};

    const PostSetMyClientCreditCard = async () => {
      setDataFetchingInfo(true, 'Setting default account', 'fullScreen');
      const res = await api.postSetClientMyCreditCard(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldSetDefaultCreditCard) void PostSetMyClientCreditCard();
    setShouldSetDefaultCreditCard(false);
    return () => {
      source.cancel();
    };
  }, [shouldSetDefaultCreditCard]);

  return [
    response,
    (_params: vp.SetMyCreditCardRequest) => {
      setParams(_params);
      setShouldSetDefaultCreditCard(true);
    },
    () => {
      setResponse({
        CreditCardToken: '',
        IsDefault: '0',
        Success: false,
        ErrorMessage: '',
      });
      setShouldSetDefaultCreditCard(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostSetMyClientCreditCard);
